import { useTranslation } from 'react-i18next';

import { breakpoints } from '@pulse-web-ui/theme';

import { useIsDesktop } from '@shared/hooks';
import { Section } from '@shared/ui';

import { useGetProfileSectionHeaderStyles } from '../../hooks';
import type {
  AgentProfileSectionProps,
  ProfileContactsData,
} from '../../model';
import { getContactsTranslations } from '../../utils';

interface ContactsSectionProps extends AgentProfileSectionProps {
  contacts: ProfileContactsData;
  contactsToCompare?: ProfileContactsData;
}

export const ContactsSection = ({
  contacts,
  contactsToCompare,
  isRenderTitle,
  isSubmitSection,
  buttonProps,
}: ContactsSectionProps) => {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop(breakpoints.DESKTOP);
  const dataLabels = getContactsTranslations(t);

  const header = useGetProfileSectionHeaderStyles({
    title: isRenderTitle ? t('AGENT_PROFILE:headers.contacts') : undefined,
    isDesktop,
    isSubmitSection,
    buttonProps,
  });

  return (
    <Section
      data={contacts}
      dataToCompare={contactsToCompare}
      dataLabels={dataLabels}
      header={header}
    />
  );
};
